import { IStrapiBaseEntity } from 'entities/Strapi';

export enum MediaType {
  img = 'img',
  video = 'video',
  pdf = 'pdf',
  other = 'other',
}

export interface IMedia extends IStrapiBaseEntity {
  readonly id: number;
  readonly type: MediaType;
  readonly name: string;
  readonly url: string;
  readonly alt: string;
  readonly width: number;
  readonly height: number;
  readonly size: number;
  // .png/.svg/...
  readonly ext: string;
  // image/png...
  readonly mime: string;
}
